import React from 'react'

const TestError = (props) => {
    const err = new Error('Test Error')
    throw err
}

export default TestError
